// extracted by mini-css-extract-plugin
export var chevron = "_nd-3";
export var chevronRotated = "_nd-4";
export var image = "_nd-1";
export var imageContainer = "_nd-0";
export var shippingAddress = "_nd-2";